import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Product Name", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productNameError"
}, null, -1)
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "UPC", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productUpcError"
}, null, -1)
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateOrUpdateProduct && _ctx.submitCreateOrUpdateProduct(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "productName",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Branded Smart Watch",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productName) = $event)),
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateProductName && _ctx.validateProductName(...args)))
              }, null, 544), [
                [_vModelText, _ctx.productName]
              ]),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "productUpc",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. 850003376356",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productUpc) = $event)),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateUpc && _ctx.validateUpc(...args)))
              }, null, 544), [
                [_vModelText, _ctx.productUpc]
              ]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.product ? 'Update' : 'Create') + " Product ", 1)
          ])
        ])
      ], 32)
    ])
  ]))
}